import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SearchInput from '../SearchInput';
import styles from './styles';
import {
  getKnowledgebasebaseCategoriesRequest,
  setKnowledgebaseFilters,
  getMoreKnowledgebaseItemsRequest,
} from '../../actionCreators/knowledgebase';
import { logFirebaseEvent } from '../../firebase/analytics';
import KnowledgebaseItem from './KnowledgebaseItem';
import GridContainer from '../global/GridContainer/GridContainer';
import { fetchFeatureFlagsRequest } from '../../actionCreators/featureFlags';
import KnowledgebaseApi from '../../api/knowledgebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Banner from '../Feed/Banner/Banner';
import { BannerApi } from '../../api';

const KnowledgebaseComponent = (props) => {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    searchText: '',
  });
  const [categories, setCategories] = useState();
  const [categorySelected, setCategorySelected] = useState(0);
  const [isSimulatingLoad, setIsSimulatingLoad] = useState(false);
  const [allBannersData, setAllBannersData] = useState([]);
  const [singleBannerData, setSingleBannerData] = useState([]);
  const loadTimerRef = React.useRef(null);
  const featureFlags = useSelector((state) => state.featureFlags);

  const scrollBlock = useRef(null);
  const contentBlock = useRef(null);
  const isFetchingMoreRef = useRef(false);

  const uniqueKnowledgebaseItems = useMemo(() => {
    const seen = new Set();
  
    return props.knowledgebaseItems.filter((item) => {
      if (seen.has(item.id)) return false;
  
      seen.add(item.id);
      return true;
    });
  }, [props.knowledgebaseItems]);

  useEffect(() => {
    props.fetchKnowledgebaseCategories();

    const fetchCategories = async () => {
      const result = await KnowledgebaseApi.getknowledgebaseCategories();
      setCategories(result.categories);
    };

    fetchCategories();
    logFirebaseEvent({
      event: 'knowledgebase',
      action: 'load',
    });
    dispatch(fetchFeatureFlagsRequest());

    return () => {
      if (loadTimerRef.current) clearTimeout(loadTimerRef.current);
    };
  }, []);

  useEffect(() => {
    isFetchingMoreRef.current = false;
  }, [uniqueKnowledgebaseItems.length]);

  useEffect(() => {
    const loadBanner = async () => {
        const data = await BannerApi.fetchBanner();
        setAllBannersData(data.data);
    };

    loadBanner();
  }, []);

  useEffect(() => {
    const firstKnowledgebaseItem = props.knowledgebaseItems?.[0];
      setSingleBannerData([])
      if (firstKnowledgebaseItem) {
        const knowledgebaseCategoryId = String(firstKnowledgebaseItem.knowledgebase_category_id);

        const found = allBannersData.some((banner) =>
          (banner.categories || []).map(String).includes(knowledgebaseCategoryId)
          );

        let bannerFiles = [];

        if (found) {
          bannerFiles = allBannersData
          .filter((banner) =>
              (banner.categories || []).map(String).includes(knowledgebaseCategoryId)
          )
          .flatMap((banner) =>
              (banner.files || []).map((file) => ({
                  image: file.image,
                  url: file.url,
              }))
          );
          setSingleBannerData(bannerFiles);
        }
      }

  }, [setAllBannersData, props.knowledgebaseItems]);


  const search = (searchText) => {
    setState({ searchText });
    props.setKnowledgebaseFilters(props.filterGroups, searchText);
  };

  const _onScroll = () => {
    if (!scrollBlock.current || !contentBlock.current) return;
    if (isFetchingMoreRef.current) return;
  
    const height = scrollBlock.current.offsetHeight;
    const scroll = scrollBlock.current.scrollTop;
    const contentHeight = contentBlock.current.offsetHeight;
  
    if (height + scroll >= contentHeight - 60) {
      isFetchingMoreRef.current = true;
      props.fetchMoreKnowledgebaseItems(props.filterGroups, state.searchText);
    }
  };

  const toggleFilterByGroupAndId = (groupId, filterId) => {
    const tmpFilterGroups = [...props.filterGroups];
    const filterGroupIndex = tmpFilterGroups.findIndex((filterGroup) => filterGroup.id === groupId);
    if (filterGroupIndex === -1) return;

    const filterIdIndex = tmpFilterGroups[filterGroupIndex].filters.findIndex(
      (filter) => filter.id === filterId,
    );
    if (filterIdIndex === -1) return;

    const isChecked = tmpFilterGroups[filterGroupIndex].filters[filterIdIndex].isChecked;
    tmpFilterGroups[filterGroupIndex].filters[filterIdIndex].isChecked = !isChecked;

    props.setKnowledgebaseFilters(tmpFilterGroups, state.searchText);
  };

  const convertFAIconName = (iconName) => {
    if (!iconName || typeof iconName !== 'string') return ['fas', 'question-circle'];

    const match = iconName.match(/^fa([A-Z].*)$/);
    if (!match) return ['fas', 'question-circle'];

    const kebab = match[1].replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

    return ['fas', kebab];
  };

  return (
    <div className="knowledgebase" ref={scrollBlock} onScroll={_onScroll}>
      <GridContainer>
        <div className="knowledgebase-header">
          <p className="knowledgebase-header-title">Knowledgebase</p>
          <p className="knowledgebase-header-subtitle-text">
            Explore files and info from around the company
          </p>
        </div>
        {featureFlags?.TILED_KNOWLEDGEBASE && categorySelected === 1 && (
          <div>
            <br />
            <p
              onClick={() => {
                setCategorySelected(0);

                const clearedFilters = props.filterGroups.map((group) => ({
                  ...group,
                  filters: group.filters.map((f) => ({ ...f, isChecked: false })),
                }));

                props.setKnowledgebaseFilters(clearedFilters, state.searchText);
              }}
              style={{ cursor: 'pointer' }}
            >
              Back to categories
            </p>
          </div>
        )}
        <div className="knowledgebase-content" ref={contentBlock}>
            <>
              <SearchInput submit={search} placeholder="Search Knowledgebase" />
              <br />
            </>
          {featureFlags?.TILED_KNOWLEDGEBASE && categorySelected === 0 && !state.searchText.length && (
            <div
              className="my-ark-knowledgebase-parent-container"
              style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}
            >
              <div
                className="my-ark-knowledgebase-parent-container"
                style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row' }}
              >
                {categories?.map((category) => (
                  <div
                    key={category.id}
                    className="my-ark-knowledgebase-child-container"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      setIsSimulatingLoad(true);
                      if (loadTimerRef.current) clearTimeout(loadTimerRef.current);
                      loadTimerRef.current = setTimeout(() => setIsSimulatingLoad(false), 1000);

                      setCategorySelected(1);
                      toggleFilterByGroupAndId('categories', category.id);
                    }}
                  >
                    <div className="my-ark-knowledgebase-category-icon-box">
                      <FontAwesomeIcon
                        icon={convertFAIconName(category.icon_name)} // returns ['fas', 'pizza-slice']
                        size="2x"
                        color={category.icon_colour ?? '#505A62'}
                      />
                    </div>
                    <div>
                      <p className="my-ark-knowledgebase-category-text">
                        {category.name.length > 15
                          ? `${category.name.slice(0, 15)}...`
                          : category.name}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {(!featureFlags?.TILED_KNOWLEDGEBASE || categorySelected === 1 || state.searchText) && (
            <>
              {isSimulatingLoad ? (
                <p>Loading...</p>
              ) : (
                <div>
                  <div style={styles.postListContainer}>
                  {singleBannerData && singleBannerData.length > 0 &&
                    <Banner data={singleBannerData} />
                  }
                </div>
                <div style={styles.postListContainer}>
                  {uniqueKnowledgebaseItems.map((item) => (
                    <KnowledgebaseItem key={item.id} item={item} />
                  ))}
                </div>
                </div>
              )}
            </>
          )}
        </div>
      </GridContainer>
    </div>
  );
};

const Knowledgebase = (props) => {
  const state = useSelector((state) => ({
    filterGroups: state.knowledgebase.filters,
    knowledgebaseItems: state.knowledgebase.items,
  }));

  const dispatch = useDispatch();

  const actions = {
    fetchKnowledgebaseCategories: () => dispatch(getKnowledgebasebaseCategoriesRequest()),
    fetchMoreKnowledgebaseItems: (filters, search) =>
      dispatch(getMoreKnowledgebaseItemsRequest({ filters, search })),
    setKnowledgebaseFilters: (filters, search) =>
      dispatch(setKnowledgebaseFilters({ filters, search })),
  };

  return <KnowledgebaseComponent {...props} {...state} {...actions} />;
};

export default Knowledgebase;
